import { css } from '@emotion/react';
import { Stack, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { SimplifiedRichTextEditor } from '../../../components/LexicalEditor/SimplifiedRichTextEditor';
import { DataCollectionEmailPreferences } from '../../../data-models/preferences-v3.data-model';

const sectionCss = css`
  border: 1px solid var(--mui-colors-neutral-30);
  border-radius: 8px;
  padding: 1rem;
`;

interface EmailTemplateSectionProps {
  title: string;
  type: 'request' | 'reminder';
}

export function EmailTemplateSection({ title, type }: EmailTemplateSectionProps) {
  const { setValue, watch, control } = useFormContext<DataCollectionEmailPreferences>();

  const header = watch(`messages.${type}.header`) ?? '';
  const body = watch(`messages.${type}.body`) ?? '';
  const contact = watch(`messages.${type}.contact`) ?? '';
  const signature = watch(`messages.${type}.signature`) ?? '';
  const footer = watch(`messages.${type}.footer`) ?? '';

  return (
    <Stack gap='1rem' css={sectionCss}>
      <Typography variant='h6'>{title}</Typography>
      <Controller
        name={`messages.${type}.subject`}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            label='Subject'
            fullWidth
            size='small'
            placeholder='Email subject line...'
          />
        )}
      />
      <SimplifiedRichTextEditor
        label='Header'
        value={header}
        onChange={(html) => setValue(`messages.${type}.header`, html, { shouldDirty: true })}
        placeholder='Enter header content...'
      />
      <SimplifiedRichTextEditor
        label='Body'
        value={body}
        onChange={(html) => setValue(`messages.${type}.body`, html, { shouldDirty: true })}
        placeholder='Enter email body content...'
      />
      <SimplifiedRichTextEditor
        label='Contact Information'
        value={contact}
        onChange={(html) => setValue(`messages.${type}.contact`, html, { shouldDirty: true })}
        placeholder='Enter contact information...'
      />
      <SimplifiedRichTextEditor
        label='Signature'
        value={signature}
        onChange={(html) => setValue(`messages.${type}.signature`, html, { shouldDirty: true })}
        placeholder='Enter signature...'
      />
      <SimplifiedRichTextEditor
        label='Footer'
        value={footer}
        onChange={(html) => setValue(`messages.${type}.footer`, html, { shouldDirty: true })}
        placeholder='Enter footer content...'
      />
    </Stack>
  );
}
